{/* Auto-generated icon - do not edit */}
import React from 'react'

interface IceCreamIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number | string
}

export const IceCreamIcon = React.forwardRef<SVGSVGElement, IceCreamIconProps>(
  ({ size = 24, color = "currentColor", ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 91 157"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        
<g clip-path="url(#clip0)">
<path d="M30.6632 18.3648C31.0012 15.9902 31.0968 13.7258 31.6724 11.59C32.9621 6.80538 35.9794 3.56111 40.8566 2.18871C43.978 1.23093 47.2714 0.968705 50.5049 1.42068C56.2807 2.32708 60.2186 6.43781 60.7371 12.247C60.8355 13.3543 60.7515 14.4787 60.7515 15.5058C61.0475 15.7775 61.3787 16.0081 61.736 16.1916C72.6441 19.4221 79.7929 26.9142 84.3184 36.9227C86.7048 42.201 87.9492 47.9846 90.0279 53.4178C91.082 56.1744 90.8247 58.4172 89.6177 61.0406C85.3994 70.2075 81.5513 79.5439 77.3356 88.7123C70.024 104.611 62.6098 120.461 55.0925 136.265C52.2932 142.129 49.0715 147.798 45.8961 153.475C43.6541 157.482 41.9174 157.298 37.7464 155.434C33.7775 153.662 32.4602 150.546 31.2138 147.071C22.5449 122.904 13.8997 98.7287 5.27851 74.5452C3.7033 70.1124 2.45113 65.5627 1.14371 61.0393C0.942811 60.1791 0.959749 59.2822 1.19338 58.4303C3.68258 48.1342 8.47659 38.5375 15.2136 30.3633C18.5039 26.366 22.4973 23.0041 26.9969 20.4435C28.2558 19.7143 29.5271 19.0074 30.6632 18.3648ZM40.0631 146.557H40.831C44.6088 138.806 48.3034 131.013 52.1817 123.312C61.9165 103.985 71.695 84.6791 81.5171 65.3954C82.1623 64.1214 82.7681 62.8277 83.3713 61.5886C83.0313 61.3529 82.9381 61.2322 82.8462 61.2335C69.9413 61.4232 57.0361 61.5617 44.1339 61.8387C33.2472 62.0737 22.3638 62.4654 11.4797 62.8139C10.5509 62.9072 9.62866 63.0566 8.71786 63.261C19.2409 91.2235 29.6523 118.89 40.0631 146.557ZM82.6887 53.5957C81.1253 45.8752 78.8432 39.1903 74.6158 33.1835C70.0273 26.6661 63.8139 22.9198 56.1072 21.3656C52.1895 20.578 48.2898 20.8647 44.3793 21.3353C36.0272 22.2375 28.2843 26.1334 22.5823 32.3027C16.8079 38.4644 12.3494 45.7383 9.47967 53.6803C9.26098 54.4408 9.09014 55.2141 8.96786 55.9959C9.93596 55.9959 10.5975 56.028 11.2545 55.9912C17.1917 55.6539 23.1238 55.1381 29.0656 54.991C44.5513 54.6064 60.0415 54.3938 75.5287 54.0761C77.7406 54.0295 79.9478 53.7847 82.6887 53.5957ZM54.4933 14.1917C54.6436 9.04208 52.5335 6.77517 47.4783 6.96879C45.915 7.04212 44.3668 7.30864 42.8689 7.76228C39.217 8.84393 37.2816 11.6964 37.258 15.725L54.4933 14.1917Z" fill={color}/>
</g>
<defs>
<clipPath id="clip0">
<rect width="89.9183" height="156.208" fill={color} transform="translate(0.804688 0.775879)"/>
</clipPath>
</defs>

      </svg>
    )
  }
)

IceCreamIcon.displayName = 'IceCreamIcon'
